module.exports = __webpack_public_path__ + "static/media/noti.a0a2469.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/noti.wav
// module id = 4R9a
// module chunks = 1